import { render, staticRenderFns } from "./RiskEditor.vue?vue&type=template&id=3c40742f&"
import script from "./RiskEditor.vue?vue&type=script&lang=js&"
export * from "./RiskEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports